/**
 * Swiper Slideshow
 *
 * TODO: See if this is used on site and remove if not
 */
document.addEventListener('DOMContentLoaded', function () {
	var carouselBlock = new Swiper('.carouselBlockSwiper', {
		loop: false,
		//slidesPerGroup: 3,
		slidesPerView: 'auto',
		threshold: 10, // Fixes issues with links inside of Swiper
		direction: 'horizontal',
		mousewheel: {
			enabled: true, // Horizontal scrolling with mouse
			releaseOnEdges: false,
			forceToAxis: true, // Avoid hijacking normal scroll
		},
		scrollbar: {
			el: '.swiper-scrollbar',
			draggable: true,
		},
		navigation: {
			nextEl: '.swiper-next',
			prevEl: '.swiper-prev',
		},
	});
});
